import React from "react";

export default function Page_404() {
  return <div>404</div>;
}
